import React from 'react'
import { Typography, Box } from '@mui/material'
import useStyles from './Style'
import homeHeart from 'src/assets/images/home/homeHeart.png'
import Image from 'next/image'
interface typoProps {
  content: string
  variant:
    | 'inherit'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline'
    | undefined
  style?: React.CSSProperties
  type: 'primary' | 'secondary' | 'tertiary' | 'subHeading'
  className?: string
  icon?: boolean
}

const CustomTypo: React.FC<typoProps> = ({
  content,
  variant,
  style,
  type,
  className,
  icon,
}) => {
  const { classes } = useStyles()
  const homeFontStyle = {
    backgroundImage:
      'linear-gradient(rgba(255, 255, 255, 1),rgba(120, 182, 255, 1),rgba(141, 137, 226, 1), rgba(151, 71, 255, 1), rgba(160, 192, 233, 1), rgba(231, 38, 191, 0.8),rgba(255, 255, 255, 0.4) ',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  }
  return (
    <Box>
      <Box className={classes.mobShow}>
        {type == 'primary' && icon ? (
          <Image
            className={classes.heartIcon}
            src={homeHeart}
            alt="hear icon"
          />
        ) : (
          ''
        )}
      </Box>
      <Box>
        <Typography
          variant={variant}
          gutterBottom
          style={
            icon && type === 'primary'
              ? { ...style, ...homeFontStyle }
              : { ...style }
          }
          className={
            type === 'primary'
              ? `${classes.articleHeading}  ${className}`
              : type === 'secondary'
              ? `${classes.articleText} ${className}`
              : `${classes.articleSecondary} ${className}`
          }
        >
          {content}
          <Box className={classes.mobHide}>
            {type == 'primary' && icon ? (
              <Image
                className={classes.heartIcon}
                src={homeHeart}
                alt="hear icon"
              />
            ) : (
              ''
            )}
          </Box>
        </Typography>
      </Box>
    </Box>
  )
}

export default CustomTypo
